import {annotation, mergedOutline2, topic, topicUuid} from "../../main/data/model/index.js";
import {DEFAULT, TOPIC_COLORS} from "../../main/constants/colors.js";

const outline: mergedOutline2 = [
	{
		topic_uuid: "Flq3RGEVTwKNdHy8X1CR7w" as topicUuid,
		topic:      {
			uuid:     "Flq3RGEVTwKNdHy8X1CR7w" as topicUuid,
			label:    "Highlighting",
			color:    TOPIC_COLORS[DEFAULT].topics[4],
			position: 1
		} as topic,
		annotations: [
			{
				"version": "2",
				"type":    "freeform",
				comment:   "<p>PowerNotes is a research, writing, AI, and academic integrity platform that helps you quickly gather and organize your research. Your research will be stored in &ldquo;cards&rdquo; like this one. Each card can be annotated (i.e. adding notes like this one to the beginning) or commented on.</p>"
			} as annotation,
			{
				"version": "2",
				"type":    "freeform",
				comment:   "<p>Once you've found some text on the page that looks interesting, simply highlight it, and a context pop-up menu will appear that shows you the topics in your current project. Select one of the topics, and save your highlight to your outline.</p>"
			} as annotation,
			{
				"version": "2",
				"type":    "freeform",
				comment:   "<p>You can also add &ldquo;freeform notes&rdquo; like this one by clicking on the icon next to the topic name.</p>"
			} as annotation
		]
	},
	{
		topic_uuid: "2JZOsXlPSR6WTmipFx2SHg" as topicUuid,
		topic:      {
			uuid:     "2JZOsXlPSR6WTmipFx2SHg" as topicUuid,
			label:    "Topic",
			color:    TOPIC_COLORS[DEFAULT].topics[7],
			position: 1
		} as topic,
		annotations: [
			{
				"version": "2",
				"type":    "freeform",
				comment:   "<p>Speaking of topics, you can create new topics from the highlighter popup menu. Try highlighting a new piece of text, and hitting the &ldquo;plus&rdquo; button at the bottom of the popup. Type in a new topic name, hit enter, and then select your new topic to save your highlight.</p>"
			} as annotation
		]
	},
	{
		topic_uuid: "14JJzXiQS3yQTn0Uj2WWdA" as topicUuid,
		topic:      {
			uuid:     "14JJzXiQS3yQTn0Uj2WWdA" as topicUuid,
			label:    "Citations",
			color:    TOPIC_COLORS[DEFAULT].topics[5],
			position: 1
		} as topic,
		annotations: [
			{
				"version": "2",
				"type":    "freeform",
				comment:   "<p>PowerNotes automatically creates a citation for you for each highlight you make, which can later be exported as a bibliography. To view this citation information, click the small quotation mark icon at the bottom left of the card. After you click on the icon, you'll be taken to the Citation Information panel, where you can change the citation format (i.e. MLA, APA, etc.) and edit the citation if necessary.</p>"
			} as annotation,
			{
				"version": "2",
				"type":    "freeform",
				comment:   "<p>PowerNotes also captures detailed citation information (metadata), which can be edited in the same panel. Here, you can adjust the title of the page, the publisher, the author or contributor(s), and see the date published and the date accessed.</p>"
			} as annotation
		]
	},
	{
		topic_uuid: "fLRJtygSTOKK5Gdvto4dhg" as topicUuid,
		topic:      {
			uuid:     "fLRJtygSTOKK5Gdvto4dhg" as topicUuid,
			label:    "Export",
			color:    TOPIC_COLORS[DEFAULT].topics[3],
			position: 1
		} as topic,
		annotations: [
			{
				"version": "2",
				"type":    "freeform",
				comment:   "<p>Once you've selected the &ldquo;Export&rdquo; icon at the top of your Project Outline, you can choose whether to export your project to Word or Excel (which can be opened in Google Docs and Sheets).</p>"
			} as annotation
		]
	}
];

export default outline;
